


























// autocomplete with a rubbish value disables autocomplete in the field
// but autocomplete="off" is ignored by browsers

import { Vue, Component, Prop } from 'vue-property-decorator';

import SelectCustom from '@/components/select/SelectCustom.vue';

import { LoadPropType, SelectValue } from './types';

@Component({
    name: 'BaseAutocomplete',
    components: {
        SelectCustom,
    }
})
export default class CityAutocomplete extends Vue {
    @Prop({ required: true }) readonly autocompleteSettings!: LoadPropType
    @Prop({ type: String, default: '' })  title!: string;
    @Prop({ type: Object, default: null }) value!: SelectValue;
    @Prop({ type: String, default: '' }) error!: string;
    @Prop({ default: false, type: Boolean }) readonly!: boolean;
    @Prop({ default: false, type: Boolean }) disabled!: boolean;
    @Prop({ default: false, type: Boolean }) noTitleGap!: boolean;

    get hasTitle() {
        return Boolean(this.title || this.$scopedSlots.title)
    }

    updateValue(value: SelectValue) {
        this.$emit('input', value);
    }

    listLoadedHandler(list: any[]) {
        this.$emit('loaded', list);
    }
}
